// extracted by mini-css-extract-plugin
module.exports = {"desktopAdStructure":"DesktopAdStructure_desktopAdStructure__2dxZP","line":"DesktopAdStructure_line__15loh","adCardTitle":"DesktopAdStructure_adCardTitle__1mY7s"};